// @flow

import { combineReducers } from 'redux';
import reduceReducers from 'reduce-reducers';
import profile from '../features/profile/reducer';
import insights from '../features/insights/reducer';
import yellowfin from '../features/yellowfin/reducer';
import auth from '../auth/reducer';
import server from '../server/reducer';
import corporateQuote from '../features/corporate-quote/reducer';
import { reducer as notifications } from 'react-notification-system-redux';
import reports from '../features/scheduling-reports/reducers';

import { reducer as form } from 'redux-form';
import corporateQuoteWorkflowSetup from '../features/corporate-quote-workflow-setup/reducer';

import relocation from '../features/relocations/reducer';
import globalSearch from '../features/common/GlobalSearch/reducer';
import globalSearchBar from '../features/common/GlobalSearchBar/store/reducer';

import notification from '../features/notification/reducer';
import globalNotification from '../features/common/GlobalNotification/reducer';
import crossCutReducer from '../reducer/CrossCutReducer';
import dashboard from '../features/dashboard/reducer';
import bookmarks from '../features/common/Bookmarks/reducer';
import common from '../reducer/CommonReducer';

import userManagement from '../features/userManagement/store/reducer';

const defaultAppReducers = {
  server,
  auth,
  corporateQuote,
  notifications,
  insights,
  yellowfin,
  reports,
  form,
  profile,
  notification,
  corporateQuoteWorkflowSetup,
  relocation,
  globalSearch,
  globalSearchBar,
  globalNotification,
  dashboard,
  bookmarks,
  common,
  userManagement
};

const mainReducer = combineReducers(defaultAppReducers);

// crosscut reducer for accessing states across multiple reducers.
const rootReducer = reduceReducers(mainReducer, crossCutReducer);

// Workaround for spread operator .. because of escodegen defect to read spread -- used by yeoman generators. - Sriram
const _extends =
  Object.assign ||
  function(target) {
    for (let i = 1; i < arguments.length; i++) {
      const source = arguments[i];
      for (const key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };

/** function used for dynamic loading of reducers -- used for code splitting by Admin and FBT modules  -Sriram */
export const createReducer = asyncReducers => {
  const asynchResultReducer = _extends({}, defaultAppReducers, asyncReducers);

  // crosscut reducer for accessing states across multiple reducers - Sriram - in case if asynch reducers
  return reduceReducers(combineReducers(asynchResultReducer), crossCutReducer);
};

/*
export const createReducer = asyncReducers => {
  return combineReducers({
    ...rootReducer,
    ...asyncReducers
  });
}; */

export default rootReducer;



// WEBPACK FOOTER //
// ./src/rootreducer/index.js